import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: 'How do I contact support?',
    answer: 'You can reach us by email at Sumittandon092@gmail.com or call 0800 055 4969. Our office hours are Monday to Friday 9am-5pm, and Saturday 9am-1pm.'
  }, {
    question: 'When does service begin?',
    answer: 'Service begins immediately after payment is confirmed and runs for 12 months from the date of purchase.'
  }, {
    question: 'How do I book a repair?',
    answer: 'You can book a repair by calling us at 0800 055 4969 or emailing Sumittandon092@gmail.com. We typically schedule appointments within 24-48 hours of your request.'
  }, {
    question: 'What appliances do you handle?',
    answer: 'We repair most household appliance models under 10 years old, including washing machines, dishwashers, tumble dryers, cookers, ovens, fridges, and freezers.'
  }, {
    question: 'What is your refund and cancellation policy?',
    answer: 'Full refunds are available within 14 days if no work has been completed. Between 15-28 days, partial refunds may be offered at our discretion. After 28 days, no refunds are available. Please see our Refund Policy and Cancellation Policy pages for full details.'
  }, {
    question: 'How are disputes handled?',
    answer: 'If you have any concerns or disputes, please contact us directly first. We aim to resolve all issues quickly and fairly. You can reach us at Sumittandon092@gmail.com or 0800 055 4969.'
  }, {
    question: 'What areas do you cover?',
    answer: 'We provide appliance repair services across England, Scotland, and Wales. Based in Portsmouth, we serve Hampshire, Sussex, Surrey, and surrounding counties. Contact us to confirm coverage in your area.'
  }, {
    question: 'Do you use genuine parts?',
    answer: 'We use high-quality replacement parts for all repairs. Where possible, we source genuine manufacturer parts. In some cases, we may use approved equivalent parts that meet or exceed original specifications. All parts are approved before fitting.'
  }, {
    question: 'What payment methods do you accept?',
    answer: 'We accept secure payments through Stripe, including all major credit and debit cards. Payment is typically due upon completion of the repair or can be made in advance for service packages.'
  }, {
    question: 'What should I do before the engineer arrives?',
    answer: 'Please ensure the appliance is accessible and that you can demonstrate the fault if possible. Have the make and model information ready. Clear the area around the appliance to allow the engineer to work safely.'
  }];
  return <div className="w-full bg-slate-50 py-16" data-id="element-332">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-333">
        <div className="text-center mb-12" data-id="element-334">
          <h1 className="text-4xl font-bold text-slate-800 mb-4" data-id="element-335">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-slate-600" data-id="element-336">
            Find answers to common questions about our appliance repair services
          </p>
        </div>
        <div className="space-y-4" data-id="element-337">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-338">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-slate-50 transition" data-id="element-339">
                <span className="font-semibold text-slate-800" data-id="element-340">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-teal-600 flex-shrink-0" data-id="element-341" /> : <ChevronDownIcon className="w-5 h-5 text-slate-400 flex-shrink-0" data-id="element-342" />}
              </button>
              {openIndex === index && <div className="px-6 pb-4 border-t border-slate-100" data-id="element-343">
                  <p className="text-slate-600 pt-4" data-id="element-344">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
        <div className="mt-12 bg-teal-50 rounded-xl p-8 text-center" data-id="element-345">
          <h2 className="text-2xl font-bold text-slate-800 mb-4" data-id="element-346">
            Still Have Questions?
          </h2>
          <p className="text-slate-600 mb-6" data-id="element-347">
            Our team is happy to help. Contact us for more information about our
            repair services.
          </p>
          <div className="flex flex-wrap gap-4 justify-center" data-id="element-348">
            <a href="tel:08000554969" className="bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-700 transition" data-id="element-349">
              Call 0800 055 4969
            </a>
            <a href="mailto:Sumittandon092@gmail.com" className="border-2 border-teal-600 text-teal-600 px-8 py-3 rounded-lg font-semibold hover:bg-teal-600 hover:text-white transition" data-id="element-350">
              Email Us
            </a>
          </div>
        </div>
      </div>
    </div>;
}